export default __webpack_public_path__ + "static/media/light-face-mask-user.62aff67b.svg";